import script from "./ExternalLogedUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalLogedUser.vue?vue&type=script&setup=true&lang=js"

import "./ExternalLogedUser.vue?vue&type=style&index=0&id=2ff0c571&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff0c571"]])

export default __exports__